import { STATUSPAGE } from '@repo/ui';
import { UpdateInternshipLocationUseCaseInterface } from 'domain/usecases';
import { notifyError, notifySuccess } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useCallback, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const useConfirmOrEditMarkerLocationOnMap = () => {
  // Hooks
  const navigate = useNavigate();
  const { internshipLocationsService } = useService();
  const { state } = useLocation();
  const { id } = useParams();

  // States
  const newMarkerLocationCoordinates = useRef(null);

  const [
    updateInternshipLocationRequestStatus,
    setUpdateInternshipLocationRequestStatus,
  ] = useState(STATUSPAGE.DONE);

  const requestUpdateInternshipLocation = useCallback(
    async (params: UpdateInternshipLocationUseCaseInterface.Params) => {
      setUpdateInternshipLocationRequestStatus(STATUSPAGE.LOADING);
      await internshipLocationsService
        .updateInternshipLocation(params)
        .then((res) => {
          notifySuccess(res.message);
          navigate(`/cadastros/locais-de-estagio/editar/${params.id}`);
        })
        .catch((err) => {
          notifyError(err.message);
        })
        .finally(() =>
          setUpdateInternshipLocationRequestStatus(STATUSPAGE.DONE),
        );
    },
    [],
  );

  return {
    id,
    state,
    newMarkerLocationCoordinates,
    updateInternshipLocationRequestStatus,
    navigate,
    requestUpdateInternshipLocation,
  };
};
